import {Chip} from '@mui/material';
import {grey} from '@mui/material/colors';

export const ActionChip = ({
  title,
  value,
  backgroundColor,
  tooltipTitle,
  notUppercase,
}: {
  title: string;
  value?: string | number | null;
  backgroundColor?: string;
  tooltipTitle?: string;
  notUppercase?: boolean;
}) => {
  const _tooltipTitle = tooltipTitle ? <div style={{whiteSpace: 'pre-line'}}>{tooltipTitle}</div> : '';

  return (
    <Chip
      size="small"
      label={`${title} ${value}`}
      sx={{
        textTransform: notUppercase ? undefined : 'uppercase',
        fontSize: '0.75rem',
        height: 18,
        marginRight: 0.5,
        letterSpacing: notUppercase ? 0.7 : 0.4,
        color: backgroundColor ? grey[900] : '',
        cursor: _tooltipTitle ? 'pointer' : 'default',
        background: backgroundColor,
        fontWeight: 600,
        minWidth: 50,
        marginBottom: 0.5,
      }}
    />
  );
};
